// 경과시간 표시 컴포넌트 (Phase 2)
//
// startedAt (ms timestamp) 을 받아 현재시각 - startedAt 을 200ms 마다 갱신해 표시.
// 형식:
//   < 60s    → "12.3s"
//   < 60m    → "5m 23s"
//   그 외     → "1h 12m"

import React, { useEffect, useState } from 'react';

function format(ms) {
    if (!Number.isFinite(ms) || ms < 0) return '';
    const totalSec = Math.floor(ms / 1000);
    if (totalSec < 60) {
        const sec = Math.floor(ms / 100) / 10; // 0.1s 정밀도
        return `${sec.toFixed(1)}s`;
    }
    if (totalSec < 3600) {
        const m = Math.floor(totalSec / 60);
        const s = totalSec % 60;
        return `${m}m ${s}s`;
    }
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    return `${h}h ${m}m`;
}

const Elapsed = ({ startedAt, className }) => {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        if (!startedAt) return undefined;
        const id = setInterval(() => setNow(Date.now()), 200);
        return () => clearInterval(id);
    }, [startedAt]);
    if (!startedAt) return null;
    return <span className={className}>{format(now - startedAt)}</span>;
};

export default Elapsed;
